import { computed, Ref, unref } from 'vue';
import { skipToken, useQuery } from '@tanstack/vue-query';
import { fetchSingleScanReport } from './report.endpoints';
import { TSingleScanReportPayload } from '../models/types';

export function useFetchSingleScanReport(payloadRef: Ref<TSingleScanReportPayload | null>) {
  const query = useQuery({
    queryKey: computed(() => {
      const payload = unref(payloadRef);
      return ['singleScanReport', payload?.jobId, payload?.folderName];
    }),
    queryFn: computed(() => {
      const payload = unref(payloadRef);
      if (!payload) {
        return skipToken;
      }

      return () => fetchSingleScanReport(payload);
    }),
  });

  return query;
}
